module.exports = __webpack_public_path__ + "img/ios_it.81d98b38.png";